/** Semi-automatic (sin autoblocking). El ID va en data-cmp-cdid, no en el path. */
const CMP_SCRIPT = {
  key: 'consentmanager',
  src: 'https://cdn.consentmanager.net/delivery/js/semiautomatic.min.js',
  type: 'text/javascript',
  'data-cmp-ab': '1',
  'data-cmp-cdid': 'd9c20897e2443',
  'data-cmp-host': 'a.delivery.consentmanager.net',
  'data-cmp-cdn': 'cdn.consentmanager.net',
  'data-cmp-codesrc': '0'
} as const

type IdleWindow = Window & {
  requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number
}

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const config = useRuntimeConfig()
  const cookiesDisabled = config.public.DISABLE_COOKIES === true
  const cmpReady = ref(false)

  useHead({
    script: computed(() => {
      if (cookiesDisabled || !cmpReady.value) {
        return []
      }
      return [{
        ...CMP_SCRIPT,
        defer: true,
        tagPosition: 'bodyClose' as const,
      }]
    }),
    style: computed(() => {
      if (cookiesDisabled) {
        return []
      }
      return [{
        key: 'cmp-ui-suppressed-style',
        innerHTML: CMP_UI_SUPPRESSED_CSS
      }]
    })
  })

  if (!import.meta.client || cookiesDisabled) {
    return
  }

  onNuxtReady(() => {
    const idleWindow = window as IdleWindow
    const schedule = idleWindow.requestIdleCallback
      ? (callback: () => void) => idleWindow.requestIdleCallback?.(callback, { timeout: 2000 })
      : (callback: () => void) => window.setTimeout(callback, 200)
    schedule(() => {
      cmpReady.value = true
      if (isCmpSuppressedPath(route.path)) {
        hideConsentManagerUi()
      }
    })
  })

  watch(
    () => route.path,
    (path, previousPath) => {
      if (isCmpSuppressedPath(path)) {
        hideConsentManagerUi()
        return
      }

      const leftHidden = previousPath !== undefined && isCmpSuppressedPath(previousPath)
      if (leftHidden) {
        restoreConsentManagerUi()
      }
    },
    { immediate: true }
  )
})
